import { render, staticRenderFns } from "./RetailGiftReceipt.vue?vue&type=template&id=8d3664ba&scoped=true&"
import script from "./RetailGiftReceipt.vue?vue&type=script&lang=js&"
export * from "./RetailGiftReceipt.vue?vue&type=script&lang=js&"
import style0 from "./RetailGiftReceipt.vue?vue&type=style&index=0&id=8d3664ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3664ba",
  null
  
)

export default component.exports